import {post, get, formPost} from "./Http";

let baseUrl = "api-tax-personal-income-server"

//查询列表
function GetSpecialTitle(query) {
  return post(`/${baseUrl}/special-deduction-title/getSpecialTitle`, query);
}

//删除
function DelSpecialTitle(query) {
  return post(`/${baseUrl}/special-deduction-title/delSpecialTitle`, query);
}

//报送
//删除
function DendSpecialTitle(query) {
  return post(`/${baseUrl}/special-deduction-title/sendSpecialTitle`, query);
}

//专项信息-子女教育、条件查询
function GetSpecialChildEdu(query) {
  return post(`/${baseUrl}/special-deduction-children-edu/getSpecialChildEdu`, query);
}

//专项信息-租房信息、条件查询
function GetSpecialInfoHouse(query) {
  return post(`/${baseUrl}/special-deduction-house/getSpecialInfoHouse`, query);
}

//专项信息赡养老人、条件查询
function GetSpecialElderly(query) {
  return post(`/${baseUrl}/special-deduction-elderly/getSpecialElderly`, query);
}

//专项信息-贷款、条件查询
function GetSpecialLoan(query) {
  return post(`/${baseUrl}/special-deduction-loan/getSpecialLoan`, query);
}

//  专项信息继续教育、条件查询
function GetSpecialLoanedu(query) {
  return post(`/${baseUrl}/special-deduction-academic-degree/getSpecialInfoAcademic`, query);
}

//  专项信息3岁以下婴幼儿照护、条件查询
function GetSpecialInfant(query) {
  return post(`/${baseUrl}/special-deduction-infant/getSpecialInfant`, query);
}

//  专项附加扣除添加
function saveSpecialTitle(query) {
  return post(`/${baseUrl}/special-deduction-title/saveSpecialTitle`, query);
}
//  专项附加扣除获取
function getSpecialTitleDetail(query) {
  return post(`/${baseUrl}/special-deduction-title/getSpecialTitleDetail`, query);
}

export default {
  GetSpecialTitle,
  DelSpecialTitle,
  DendSpecialTitle,
  GetSpecialInfoHouse,
  GetSpecialChildEdu,
  GetSpecialLoan,
  GetSpecialElderly,
  GetSpecialLoanedu,
  GetSpecialInfant,
  saveSpecialTitle,
  getSpecialTitleDetail
}



// WEBPACK FOOTER //
// ./src/api/specialDeductionsApi.js